import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="navigation"
export default class extends Controller {
  static targets = ["mobileMenu", "menuButton", "menuIcon", "closeIcon", "backdrop"]

  connect() {
    // Initialize the menu as closed
    this.isOpen = false

    // Store original body overflow for restoration
    this.originalBodyOverflow = null

    // Close menu on escape key
    this.escapeHandler = this.handleEscape.bind(this)
    document.addEventListener("keydown", this.escapeHandler)
  }

  disconnect() {
    // Clean up event listeners when controller is removed
    document.removeEventListener("keydown", this.escapeHandler)

    // Restore body scroll if needed
    if (this.originalBodyOverflow !== null) {
      document.body.style.overflow = this.originalBodyOverflow
    }
  }

  toggle(event) {
    // Prevent click from bubbling
    event.stopPropagation()

    if (this.isOpen) {
      this.close()
    } else {
      this.open()
    }
  }

  open() {
    this.isOpen = true

    // Prevent body scroll when menu is open
    this.originalBodyOverflow = document.body.style.overflow
    document.body.style.overflow = "hidden"

    // Show backdrop
    this.backdropTarget.classList.remove("hidden")

    // Force reflow to ensure transition works
    this.backdropTarget.offsetHeight

    // Fade in backdrop
    this.backdropTarget.classList.remove("bg-opacity-0")
    this.backdropTarget.classList.add("bg-opacity-50")

    // Show mobile menu (removes hidden and display:none)
    this.mobileMenuTarget.classList.remove("hidden")

    // Force reflow to ensure transition works
    this.mobileMenuTarget.offsetHeight

    // Slide in menu from right (remove translate-x-full)
    this.mobileMenuTarget.classList.remove("translate-x-full")
    this.mobileMenuTarget.classList.add("translate-x-0")

    // Swap icons (hide hamburger, show X)
    this.menuIconTarget.classList.add("hidden")
    this.closeIconTarget.classList.remove("hidden")

    // Update ARIA attributes for accessibility
    this.menuButtonTarget.setAttribute("aria-expanded", "true")
  }

  close() {
    this.isOpen = false

    // Restore body scroll
    if (this.originalBodyOverflow !== null) {
      document.body.style.overflow = this.originalBodyOverflow
      this.originalBodyOverflow = null
    }

    // Fade out backdrop
    this.backdropTarget.classList.remove("bg-opacity-50")
    this.backdropTarget.classList.add("bg-opacity-0")

    // Slide out menu to right
    this.mobileMenuTarget.classList.remove("translate-x-0")
    this.mobileMenuTarget.classList.add("translate-x-full")

    // After animation completes, hide the menu and backdrop
    setTimeout(() => {
      if (!this.isOpen) {
        this.mobileMenuTarget.classList.add("hidden")
        this.backdropTarget.classList.add("hidden")
      }
    }, 300) // Match the transition duration (duration-300)

    // Swap icons (show hamburger, hide X)
    this.menuIconTarget.classList.remove("hidden")
    this.closeIconTarget.classList.add("hidden")

    // Update ARIA attribute
    this.menuButtonTarget.setAttribute("aria-expanded", "false")
  }

  handleEscape(event) {
    // Close menu when Escape key is pressed
    if (event.key === "Escape" && this.isOpen) {
      this.close()
    }
  }
}
